// extracted by mini-css-extract-plugin
module.exports = {"container":"ServerErrorPage_container__33bEx","title":"ServerErrorPage_title__3ZlBV","text":"ServerErrorPage_text__4ShV9"};